import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../cmsConfig';
import { ContentPage } from '../../types/ContentPageSection';
export interface ReactConfig {
  applicationInsightsConnectionString: string;
}

export const contentApi = createApi({
  reducerPath: 'contentApi',
  baseQuery: fetchBaseQuery({ baseUrl: cmsApiConfig.url }),
  endpoints: (builder) => ({
    getContentPage: builder.query<ContentPage, number>({
      query: (id: number) => ({
        url: `/start/content/${id}`,
        headers: {
          'X-CSRF': '1',
        },
        credentials: 'include',
      }),
    }),
  }),
});

export const { useLazyGetContentPageQuery } = contentApi;
